"use client"

import { MoveLeft } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MoveLeftIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MoveLeftIcon = component(Icon)({ as: MoveLeft })
